import isUndefined from 'lodash/isUndefined';
import { createSelector } from 'reselect';

import { RootState } from 'src/config/rootStore';

export const getAssessmentsState = (state: RootState) => state.assessments;
export const getAssessments = (state: RootState) => state.assessments.assessments;
export const getScores = (state: RootState) => state.assessments.scores;

export const getMostRecentAssessmentDate = (state: RootState) =>
    state.assessments.mostRecentAssessmentDate;

export const getWho5Questions = createSelector(
    getAssessments,
    (_state, includeEmploymentHealthQuestions) => includeEmploymentHealthQuestions,
    (assessments, includeAdditionalQuestions) => {
        const who5Questions = assessments['who5']?.assessmentQuestions || [];

        if (!includeAdditionalQuestions) {
            return who5Questions;
        }

        const employmentHealthQuestions =
            assessments['employment_health']?.assessmentQuestions || [];

        return [...who5Questions, ...employmentHealthQuestions];
    },
);

export const getHeaderTextByAssessmentName = createSelector(
    getAssessments,
    (_state, name: string) => name,
    (assessments, name) => {
        return assessments[name]?.headerText || '';
    },
);

export const getWho5Score = createSelector(getAssessmentsState, ({ scores }) =>
    isUndefined(scores.who5) ? -1 : scores.who5,
);
export const getGad2Score = (state: RootState) => getAssessmentsState(state).scores.gad2;
export const getPhq2Score = (state: RootState) => getAssessmentsState(state).scores.phq2;

export const getWho5ScoreFetched = createSelector(
    getAssessmentsState,
    ({ scores }) => !isUndefined(scores.who5),
);

export const hasValidWho5Score = createSelector(getWho5Score, score => !!score || score === 0);
